<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->

    <div v-if="showPage==1">
      <transition :name="transitionName">
        <router-view name="mobile"></router-view>
      </transition>
    </div>
    <div v-else-if="showPage==2">
      <transition :name="transitionName">
        <router-view name="pc"></router-view>
      </transition>
    </div>
    <div v-else-if="showPage==3">
      <transition :name="transitionName">
        <router-view name="pcIE"></router-view>
      </transition>
    </div>

  </div>
</template>

<script>
// import DevicePixelRatio from '@/utils/rem'

export default {
  name: 'App',
  data(){
    return {

      showPage:1,
      transitionName: 'slide-left'
    }
  },
  beforeRouteUpdate (to, from, next) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      next()
    },
  created(){
    if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
      this.showPage=1
    }else{
      console.log('这是：'+navigator.userAgent)
      var isIE = navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = navigator.userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 = navigator.userAgent.indexOf('Trident') > -1 && navigator.userAgent.indexOf("rv:11.0") > -1;
      if(isIE||isEdge||isIE11){
         this.showPage=3
      }else{
        this.showPage=2
      }

    }
    // new DevicePixelRatio().init()
  },
}
</script>

<style lang="less">
body {
  margin: 0px !important;
  padding: 0px !important;
  height: auto;
  width: auto;
  background: #E6E6E6;
  font-family: '思源黑体';
}
#app {

}
  .el-select-dropdown__item.selected{
      color:#0062a4 !important;
    }
    ::-webkit-scrollbar {
      width: 5px;
      height: 8px;
      background: #F3F3F3;
    }

    ::-webkit-scrollbar-button {
      display: none;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #C1C2C2;
    }

    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #F3F3F3;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue